<script lang="ts">
	interface Props {
		text?: string
		href: string
		medium?: boolean
		large?: boolean
		small?: boolean
		subtitle?: string
		download?: boolean
		target?: string
	}

	let { text, href, subtitle, medium, large, small, download, target }: Props = $props()
</script>

<div class="link">
	<svelte:element
		this={href ? 'a' : 'div'}
		class={href ? 'anchor' : 'heading'}
		class:medium
		class:large
		class:small
		{href}
		target={target || href.includes('/documents/') ? '_blank' : undefined}
		download={download || undefined}
		title={text}
	>
		<div class="text">{text}</div>
		{#if href}
			<div class="icon" class:medium class:large>
				<svg class="svg" class:download>
					<use xlink:href="/images/vector.svg#{download ? 'download' : 'arrow-up-right'}"></use>
				</svg>
				<svg class="svg" class:download>
					<use xlink:href="/images/vector.svg#{download ? 'download' : 'arrow-up-right'}"></use>
				</svg>
			</div>
		{/if}
	</svelte:element>
	{#if subtitle}
		<div class="subtitle">{subtitle}</div>
	{/if}
</div>

<style lang="css">
	.link {
		flex-shrink: 1;

		+ :global(p) {
			margin-block-start: 2rem !important; /* keep an eye on this */
		}
	}

	.anchor {
		align-items: center;
		border-bottom: 1px solid var(--c-foreground, currentColor);
		color: var(--c-foreground, currentColor);
		display: flex;
		font: 500 var(--f-body1);
		justify-content: space-between;
		letter-spacing: var(--ls-body1);
		max-width: 25rem;
		padding-block: 0.75rem;
		width: 100%;

		@media (--from-mobile) {
			padding-block: 1rem;
		}

		.text {
			transition: translate 0.3s ease;
			/* white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis; */
		}

		&.small {
			font: 500 var(--f-h5);
			letter-spacing: var(--ls-h5);
		}

		&.medium {
			font: 500 var(--f-h4);
			letter-spacing: var(--ls-h4);
		}

		&.large {
			border-bottom-width: 2px;
			font: 500 var(--f-h3);
			letter-spacing: var(--ls-h3);
			max-width: none;
		}

		&:hover {
			.text {
				translate: 1rem 0;
			}

			.svg {
				translate: 100% -100%;

				&.download {
					translate: 0% 100%;
				}

				& + .svg {
					translate: 0% 0%;

					&.download {
						translate: 0% 0%;
					}
				}
			}
		}
	}

	.heading {
		border-bottom: 1px solid var(--c-midground);
		color: var(--c-midground);
		font: 500 var(--f-h5);
		letter-spacing: var(--ls-h5);
		max-width: 25rem;
		padding-block: 0.75rem;
		width: 100%;

		@media (--from-mobile) {
			padding-block: 1rem;
		}
	}

	.icon {
		flex: 0 0 auto;
		margin-inline-start: 1.75rem;
		overflow: clip;
		size: 1.5rem;

		&.medium {
			size: 2rem;
		}

		&.large {
			size: 2.5rem;
		}
	}

	.svg {
		transition: translate 0.3s ease;
		position: absolute;
		size: 100%;

		& + .svg {
			translate: -100% 100%;

			&.download {
				translate: 0% -100%;
			}
		}
	}

	.subtitle {
		color: var(--c-midground, currentColor);
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);
		margin-block-start: 1rem;
	}
</style>
